/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextbulletlist3Inputs */

const en_richtextbulletlist3 = /** @type {(inputs: Richtextbulletlist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulleted list`)
};

const de_richtextbulletlist3 = /** @type {(inputs: Richtextbulletlist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufzählung`)
};

/**
* | output |
* | --- |
* | "Bulleted list" |
*
* @param {Richtextbulletlist3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextbulletlist3 = /** @type {((inputs?: Richtextbulletlist3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextbulletlist3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextbulletlist3(inputs)
	return de_richtextbulletlist3(inputs)
});
export { richtextbulletlist3 as "richTextBulletList" }